import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nameInput"];

  connect() {
    this.submitButton = document.getElementById("chat-group-submit-button");
    this.avatarPreview = document.getElementById("avatar-preview");
    this.validate();
  }

  validate() {
    const input = this.hasNameInputTarget
      ? this.nameInputTarget
      : this.element.querySelector("#group_name");
    const name = input ? input.value.trim() : "";
    const isValid = name.length > 0;

    const btn = this.submitButton || document.getElementById("chat-group-submit-button");
    if (btn) {
      btn.disabled = !isValid;
    }

    const preview = this.avatarPreview || document.getElementById("avatar-preview");
    if (preview && preview.classList.contains("bryght-room-avatar--initials")) {
      const initial = name.charAt(0).toUpperCase() || "G";
      preview.textContent = initial;
    }
  }
}
